export const GET_VALIDATION_DOCS = 'app/Validation/GET_PROFILE_REPERTOIRE';
export const SET_PRODUCTION = 'app/Validation/SET_PRODUCTION';
export const ADD_DOCUMENT = 'app/Validation/ADD_DOCUMENT';
export const DELETE_DOCUMENT = 'app/Validation/DELETE_DOCUMENT';
export const REQUEST_RED_MASK = 'app/Validation/REQUEST_RED_MASK';
